/**
 * Route gate for the Modifications module (desk, 2026-10-07): open ONLY to a user an administrator has selected as a correction
 * APPROVER, as the server reads the selection now (`GET /financial/correction-workflow/me`).
 *
 * It does not look at roles or permissions on purpose. The SuperAdmin and the System Administrator hold every permission and every
 * module, and must still be turned away here unless they have been selected as an approver. While the answer is loading nothing is
 * shown, and if it cannot be had the user is sent to /403 — a door that opens late is better than one that opens for someone the
 * server will refuse. The server is the real gate (`CorrectionWorkflowService.assertApprover`); this is the courtesy in front of it.
 * Always nested INSIDE `ProtectedRoute`.
 */
import type { JSX } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Skeleton } from '@components/ui-tw';
import { useCorrectionWorkflowMe } from '@features/billing/hooks/useCorrectionWorkflow';

export function CorrectionApproverRoute(): JSX.Element {
  const me = useCorrectionWorkflowMe();

  if (me.isLoading) return <Skeleton className="tw:m-3 tw:h-48" />;
  if (!me.data?.isApprover) return <Navigate to="/403" replace />;

  return <Outlet />;
}
